import React, { useMemo } from 'react'
import { Table as TableAnt } from 'antd'
import { TableProps, ColumnProps as ColumnPropsAnt } from 'antd/lib/table'

import { useT } from 'src/core/hooks/use-translation'
import { Empty } from '..'

export interface ColumnProps<T> extends Omit<ColumnPropsAnt<T>, 'align'> {
  align?: 'left' | 'right' | 'center'
}

function Table<T>({
  dataSource: dataSourceBase = [],
  columns: baseColumns = [],
  ...props
}: TableProps<T> & {
  currentPage?: number
  totalPages?: number
}) {
  const { t } = useT()
  const columns: ColumnProps<T>[] = useMemo(
    () =>
      baseColumns.map(({ title, ...props }: ColumnProps<T>) => ({
        ...props,
        title: t(title)
      })),
    [baseColumns, t]
  )
  const dataSource = useMemo(
    () => dataSourceBase.map((item, index) => ({ ...item, key: index })),
    [dataSourceBase]
  )

  return (
    <TableAnt
      {...props}
      columns={columns}
      dataSource={dataSource}
      locale={{
        collapse: t('web.table.collapse'),
        emptyText: <Empty />,
        expand: t('web.table.expand'),
        // filterConfirm: React.ReactNode
        // filterReset: React.ReactNode
        filterTitle: t('web.table.filter-title'),
        // selectAll: React.ReactNode
        // selectInvert: React.ReactNode
        sortTitle: t('web.table.sort-title')
      }}
    />
  )
}

export default Table
